  document.addEventListener('DOMContentLoaded', function() {
    const questions = document.querySelectorAll('.faq-question');
    questions.forEach(function(question) {
      question.addEventListener('click', function() {
        const content = this.nextElementSibling;
        const isOpen = content.style.display === 'block';

        // Chiudi tutte le FAQ
        questions.forEach(function(otherQuestion) {
          otherQuestion.nextElementSibling.style.display = 'none';
          otherQuestion.querySelector('.faq-toggle').textContent = '+';
          otherQuestion.classList.remove('is-open');
          otherQuestion.parentNode.classList.remove('is-open');
          otherQuestion.setAttribute('aria-expanded', 'false');
        });

        // Apri questa FAQ se prima era chiusa
        if (!isOpen) {
          content.style.display = 'block';
          this.querySelector('.faq-toggle').textContent = '-';
          this.classList.add('is-open');
          this.parentNode.classList.add('is-open');
          this.setAttribute('aria-expanded', 'true');
        }
      });
    });
  });

